import React, { createContext, useState, useEffect } from 'react';
export const UserContext = createContext(null);
export function tokenExpiry(token) {
  try {
    const encoded=token.split('.')[1].replace(/-/g,'+').replace(/_/g,'/');
    const payload=JSON.parse(atob(encoded.padEnd(Math.ceil(encoded.length/4)*4,'=')));
    return Number.isFinite(payload.exp)?payload.exp*1000:0;
  } catch {return 0;}
}
export const UserProvider = ({ children }) => {
  const [currentUser,setCurrentUser]=useState(null),[token,setToken]=useState(null);
  useEffect(()=>{
    const storedToken=localStorage.getItem('token');
    try {
      const user=JSON.parse(localStorage.getItem('currentUser'));
      if(storedToken&&user&&tokenExpiry(storedToken)>Date.now()){setToken(storedToken);setCurrentUser(user);return;}
    } catch {}
    localStorage.removeItem('token');localStorage.removeItem('currentUser');localStorage.removeItem('profileImageUrl');
  },[]);
  useEffect(()=>{
    if(!token)return;
    let timer;
    const check=()=>{
      clearTimeout(timer);
      const remaining=tokenExpiry(token)-Date.now();
      if(remaining<=0){
        localStorage.removeItem('token');localStorage.removeItem('currentUser');localStorage.removeItem('profileImageUrl');
        setToken(null);setCurrentUser(null);return;
      }
      timer=setTimeout(check,Math.min(remaining,2147483647));
    };
    check();window.addEventListener('focus',check);document.addEventListener('visibilitychange',check);
    return ()=>{clearTimeout(timer);window.removeEventListener('focus',check);document.removeEventListener('visibilitychange',check);};
  },[token]);
  return <UserContext.Provider value={{currentUser,setCurrentUser,token,setToken}}>{children}</UserContext.Provider>;
};
